<template>
  <div class="login-container">
    <div class="login-form">
      <h2>{{ $t('login.title') }}</h2>
      <div v-if="registrationSuccess" class="success-message">
        {{ $t('login.registration_success') }}
      </div>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="email">{{ $t('login.email') }}:</label>
          <input 
            id="email" 
            v-model="loginForm.email" 
            type="email" 
            required 
            :placeholder="$t('login.placeholder_email')"
          />
        </div>
        <div class="form-group">
          <label for="password">{{ $t('login.password') }}:</label>
          <input 
            id="password" 
            v-model="loginForm.password" 
            type="password" 
            required 
            :placeholder="$t('login.placeholder_password')"
          />
        </div>
        <button type="submit" :disabled="loading">
          {{ loading ? $t('login.logging_in') : $t('login.login') }}
        </button>
      </form>
      <p class="register-link">
        {{ $t('login.dont_have_account') }} <router-link to="/register">{{ $t('login.register_now') }}</router-link>
      </p>
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { encryptUserData, decryptUserData } from '../utils/web-crypto'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      loading: false,
      errorMessage: '',
      registrationSuccess: false
    }
  },
  mounted() {
    // 检查是否有注册成功的查询参数
    const urlParams = new URLSearchParams(window.location.search);
    this.registrationSuccess = urlParams.get('registrationSuccess') === 'true';
  },
  methods: {
    async handleLogin() {
      this.loading = true
      this.errorMessage = ''
      
      try {
        // 生成设备ID（在实际应用中，这应该是唯一的设备标识符）
        const deviceId = 'DEVICE-web';
        const deviceInfo = JSON.stringify({
          userAgent: navigator.userAgent,
          platform: navigator.platform,
          language: navigator.language,
          timestamp: new Date().toISOString()
        });
        
        // 准备登录数据
        const loginData = {
          e: this.loginForm.email,
          p: this.loginForm.password,
          did: deviceId,
          di: deviceInfo
        };
        
        // 加密登录数据
        const encryptedData = await encryptUserData(loginData);
        
        // 发送加密的请求
        const response = await axios.post('/api/auth/login', { encryptedData }, {
          headers: {
            'Accept-Language': this.$i18n.locale,
            'x-client-id': 'web'
          }
        })
        
        if (response.data.success) {
          // 解密服务器响应数据
          const decryptedData = await decryptUserData(response.data.encryptedData);
          
          // 保存令牌（从解密的数据中获取）
          localStorage.setItem('token', decryptedData.t || '')
          
          // 保存用户信息（包含许可证密钥）
          localStorage.setItem('userInfo', JSON.stringify(decryptedData));
          
          this.$router.push('/')
        } else {
          // 直接显示后端返回的国际化错误消息
          this.errorMessage = response.data.message
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          // 处理服务器返回的具体错误
          this.errorMessage = error.response.data.message
        } else {
          this.errorMessage = this.$t('login.error_generic')
        }
        console.error('登录错误:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 20px;
}

.login-form {
  width: 100%;
  max-width: 400px;
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.login-form h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #555;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
}

button {
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover:not(:disabled) {
  background-color: #0056b3;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.register-link {
  text-align: center;
  margin-top: 15px;
  color: #666;
}

.register-link a {
  color: #007bff;
  text-decoration: none;
}

.register-link a:hover {
  text-decoration: underline;
}

.success-message {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #d4edda;
  color: #155724;
  border-radius: 4px;
  text-align: center;
}

.error-message {
  margin-top: 15px;
  padding: 10px;
  background-color: #f8d7da;
  color: #721c24;
  border-radius: 4px;
  text-align: center;
}
</style>
